"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.regexp.search");
var _NewLandingEdit = _interopRequireDefault(require("./NewLandingEdit.vue"));
var _NewLandingTable = _interopRequireDefault(require("./NewLandingTable.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'NewLanding',
  // 装修中心-上新落地页
  components: {
    NewLandingTable: _NewLandingTable.default,
    NewLandingEdit: _NewLandingEdit.default
  },
  data: function data() {
    return {
      activeName: 'table',
      newLandingId: null
    };
  },
  created: function created() {},
  methods: {
    handleSuccess: function handleSuccess() {
      this.activeName = 'table';
      this.$refs.new_landing_table.search();
    },
    addActivity: function addActivity() {
      this.activeName = 'config';
    },
    handleClick: function handleClick(tab) {
      this.activeName = tab.name;
      if (tab.name === 'table') {
        this.newLandingId = null;
      }
    },
    editActivity: function editActivity(newLandingId) {
      this.activeName = 'config';
      this.newLandingId = newLandingId;
    }
  }
};